export default __webpack_public_path__ + "static/media/incoming.d2f0f51e.svg";